const state = {
  uploadImgs: "https://resource.darsing.net/api/v1/img/",
  uploadFiles: "https://resource.darsing.net/api/v1/file",
  navShow: true,
};
const mutations = {
  SET_NAV_SHOW: (state, { navShow }) => {
    state.navShow = navShow;
  },
};
export default {
  namespaced: true,
  state,
  mutations,
};
